import React, {useState, useEffect} from "react"
import Swal from 'sweetalert2'
import axios from "axios";
import ProductItem from "../components/Product/ProductItem.jsx";
import fetch from "isomorphic-fetch";
import {useCookies} from "react-cookie";


// creating `context`
const StateContext = React.createContext();


function StateProvider({children}) {

    const [cookiesCart, setCookieCart] = useCookies(['cartIt'])
    const [cookiesCartTotal, setCookieCartTotal] = useCookies(['totalIt'])
    const [cookiesFavor, setCookieCartFavor] = useCookies(['favorIt'])

    //выбор языка
    const [lang, setLang] = useState("ua")
    // defining `state` for our product data
    const [products, setProducts] = useState([{}])
    // defining `state` for our car data
    const [cars, setCars] = useState([{}])
    // defining `state` for our cart data
    const [cartItems, setCartItems] = useState(cookiesCart.cartIt ? cookiesCart.cartIt : [])
    // defining `state` for calculating total amount
    const [total, setTotal] = useState(0);
    // defining `state` for counting total items in
    const [totalItems, setTotalItems] = useState(cookiesCartTotal.totalIt ? cookiesCartTotal.totalIt : 0);
    // defining `state` for favorite product data
    const [favoriteItems, setFavoriteItems] = useState(cookiesFavor.favorIt ? cookiesFavor.favorIt : [])
    // defining `state` for pages
    //const [count, setCount] = useState(0);
    // defining `state` for pages
    const [models, setModels] = useState([{}])


    // fetching product data
    const url_parts_r = "https://zapauto.com.ua/backend/api/parts/read.php"
    const url_parts_selectmodel_r = "https://zapauto.com.ua/backend/api/parts/read.php?model="
    const url_partsSearch_r = "https://zapauto.com.ua/backend/api/parts/readSearch.php?search="
   // const url_count = "https://zapauto.com.ua/backend/api/parts/read.php?count=getCount"
    const url_cars_r = "https://zapauto.com.ua/backend/api/cars/read.php"
    const url_orders_p = "https://zapauto.com.ua/backend/api/orders/insert.php"
    const url_models_r = "https://zapauto.com.ua/backend/api/models/read.php"
  //  const url_courseUSD_r = "https://api.privatbank.ua/p24api/pubinfo?json&exchange&coursid=5"

    const [offset, setOffset] = useState(0);
    const [parts, setData] = useState([]);
    const [partsSearch, setDataSearch] = useState(0)
    const [perPage] = useState(20)
    const [pageCount, setPageCount] = useState(0)
    const [searchRequest, setSearchRequest] = useState('')
    const [searchURL, setSearchURL] = useState('')
    const [P, setP] = useState('')
    const [courseUSD, setCourseUSD] = useState(47)


    const getParts = async (modelId, pageURL) => {
        let slice = "";
        let partsS = "";


            if(modelId){
                const res = await axios.get(url_parts_selectmodel_r + modelId);
                partsS = res.data;
                setP(res.data);
            }
            else {
                const res = await axios.get(url_parts_r);
                partsS = res.data;
                setP(res.data);
            }



      //  console.log(partsS);

        if(modelId){

            modelId = modelId.split(',');
            let partsFiltered = [];

            modelId.map(m => partsFiltered = partsFiltered.concat(partsS.filter(function(part) {
                return part.CAR_ID === m})) );
            setPageCount(Math.ceil(partsFiltered.length / perPage))
            slice = partsFiltered.slice(offset, offset + perPage)

        }
        else{

            setPageCount(Math.ceil(partsS.length / perPage))
            if(pageURL){
                slice = partsS.slice(pageURL * perPage, pageURL * perPage + perPage)
            }
            else{
                slice = partsS.slice(offset, offset + perPage)
            }

        }

        if(modelId) {
          //  console.log(modelId)
            const postData = slice.map((product, i) => <ProductItem key={product.ID} product={product}/>)
            setData(postData)
        }
        else {
            const postData = slice.map((product, i) => <ProductItem key={product.ID} product={product}/>)
            setData(postData)
        }

    }

    const getPartsSearch = async (searchRequest) => {

        //console.log(searchRequest)
        setDataSearch(0)

        try {
            if(searchRequest !== ""){
            const res = await axios.get(url_partsSearch_r + searchRequest)
            const partsSearch = res.data;
            // console.log(totalItems)
            const postData = partsSearch.map((product, i) => <ProductItem key={i} product={product}/>)
            setDataSearch(postData)
          //  setSearchRequest(searchRequest + ' - Not found')
            }
        } catch (err) {
            if(lang === "ua") {
                setDataSearch(searchRequest + ' - Не знайдено')
            }
            if(lang === "ru") {
                setDataSearch(searchRequest + ' - Не найдено')
            }
            if(lang === "en") {
                setDataSearch(searchRequest + ' - Not found')
            }
            setSearchRequest('')
        }


    }


    const sendOrderRequest = async (newOrder) => {
        try {
            const resp = await axios.post(url_orders_p, newOrder);
            //console.log(resp)
            if (resp === false) {
                return false
            } else {
                return true
            }

        } catch (error) {
            console.log(Object.keys(error), error.message)
            return false
        }
    }


    useEffect(() => {
        fetch(url_parts_r)
            .then(response => response.json()) // get json data from api
            .then(data => setProducts(data)) // save data to `state`
    }, [])

    useEffect(() => {
        fetch(url_cars_r)
            .then(response => response.json()) // get json data from api
            .then(data => setCars(data)) // save data to `state`


    }, [])

    useEffect(() => {
        fetch(url_models_r)
            .then(response => response.json()) // get json data from api
            .then(data => setModels(data)) // save data to `state`


    }, [])

 //   useEffect(() => {
 //       fetch(url_count)
 //           .then(response => response.json()) // get json data from api
 //           .then(data => setCount(data)) // save data to `state`

 //   }, [])

    useEffect(() => {
        // calculate total bill
            const totalPrices = cartItems.reduce((total, product) => total + product.PRICE_USD * product.QUANTITY, 0).toFixed(2);
            setTotal(totalPrices);



    }, [totalItems, cartItems])

 /*   useEffect(() => {
        fetch(url_courseUSD_r)
            .then(response => response.json()) // get json data from api
            .then(data => setCourseUSD(Math.round(data[0].sale))) // save data to `state`
    }, []) */

    useEffect(() => {
        setCookieCartFavor('favorIt', favoriteItems, { path: '/' })
    }, [favoriteItems])




    // calculate pages
    // function calcPages() {
    // console.log(count["COUNT(*)"]);
    //    return Math.ceil(count["COUNT(*)"] / 50)
    // }


    // calculate cart quantity
    function calcQuantity() {
        const totalQty = cartItems.reduce((total, product) => total + product.QUANTITY, 0)
        setTotalItems(totalQty)
        setCookieCartTotal('totalIt', totalQty, { path: '/' })
        console.log(cookiesCart.totalIt)

    }


    // addToCart button functionality
    function addToCart(product) {
        // check if the newly added product is already in cart by getting it's index
        const index = cartItems.findIndex(item => item.ID === product.ID);
        // if index not found push it to cart & set quantity to 1 else update the quantity only
        if (index === -1) {
            cartItems.push({...product, QUANTITY: 1})
        } else {
            cartItems[index].QUANTITY += 1
        }

        setCookieCart('cartIt', cartItems, { path: '/' })

        // update cart quantity
        calcQuantity()
    }

    // removeFromCart button functionality
    function removeFromCart(product) {
        // remove product from cart
        cartItems.pop(product)
        setCookieCart('cartIt', cartItems, { path: '/' })
        // update cart quantity
        calcQuantity()
    }

    // counter increase button functionality
    function increaseCount(id) {
        // check if the newly added product is already in cart by getting it's index
        const index = cartItems.findIndex(item => item.ID === id);
        // increase the quantity by 1
        cartItems[index].QUANTITY += 1
        setCookieCart('cartIt', cartItems, { path: '/' })
        // update cart quantity
        calcQuantity()
    }

    // counter decrease button functionality
    function decreaseCount(id) {
        // check if the newly added product is already in cart by getting it's index
        const index = cartItems.findIndex(item => item.ID === id);
        // decrease the quantity by 1
        cartItems[index].QUANTITY -= 1
        // update cart quantity
        calcQuantity()
    }

    // addToFavorite button functionality
    function addToFavorite(newItem) {
        setFavoriteItems(prevItems => [...prevItems, newItem])
    }


    // removeFromFavorite button functionality
    function removeFromFavorite(id) {
        setFavoriteItems(prevItems => prevItems.filter(item => item.ID !== id))
       // setCookieCartFavor('favorIt', prevItems => prevItems.filter(item => item.ID !== id), { path: '/' })
        console.log(cookiesFavor)
    }

    function resetCart() {
        setCartItems([])
        setTotalItems(0)
        setCookieCart('cartIt', [], { path: '/' })
        setCookieCartTotal('totalIt', 0, { path: '/' })
    }


    function checkOutCart(newOrder) {


        console.log(newOrder)
        let message = "";

        if(lang === "ua"){
            message = {
                checkOutCart: {
                    titleSuccess: "Успішно!",
                    htmlSuccess: "Замовлення відправлено",
                    titleError: "Помилка!",
                    htmlError: "Для замовлення, зателефонуйте за номером +38 (068) 822-52-52"
                }}}

        if(lang === "ru"){
            message = {
                checkOutCart: {
                    titleSuccess: "Успешно!",
                    htmlSuccess: "Заказ отправлен",
                    titleError: "Ошибка!",
                    htmlError: "Для заказа, позвоните по номеру +38 (068) 822-52-52"
                }}}

        if(lang === "en"){
            message = {
                checkOutCart: {
                    titleSuccess: "Success!",
                    htmlSuccess: "Order sended",
                    titleError: "Error!",
                    htmlError: "For order, please call +38 (068) 822-52-52"
                }}}




        if (sendOrderRequest(newOrder)) {
            resetCart()

            Swal.fire(
                message.checkOutCart.titleSuccess,
                message.checkOutCart.htmlSuccess,
                'success'
            )
        } else {
            Swal.fire(
                message.checkOutCart.titleError,
                message.checkOutCart.htmlError,
                'error'
            )
        }

    }




    return (
        <StateContext.Provider value={{
            cookiesCart,
            lang,
            setLang,
            setSearchRequest,
            searchRequest,
            searchURL,
            setSearchURL,
            setOffset,
            offset,
            parts,
            partsSearch,
            perPage,
            pageCount,
            models,
            cars,
            courseUSD,
            products,
            total,
            totalItems,
            cartItems,
            favoriteItems,
            getParts,
            getPartsSearch,
            addToCart,
            removeFromCart,
            addToFavorite,
            removeFromFavorite,
            increaseCount,
            decreaseCount,
            resetCart,
            checkOutCart,

        }}>
            {children}
        </StateContext.Provider>
    )
}

export {StateContext, StateProvider}